import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, map, mergeMap, startWith } from 'rxjs/operators';

import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  router = inject(Router);

  private activatedRoute = inject(ActivatedRoute);
  private launchDarklyService = inject(LaunchDarklyService);

  activeRoute$ = new BehaviorSubject('');
  focusEvent$ = new Subject();
  paramMap$ = new BehaviorSubject<null | ParamMap>(null);

  constructor() {
    this.router.events
      .pipe(
        startWith(this.router.url),
        map((route) => {
          if (typeof route === 'string') {
            this.activeRoute$.next(route);
          } else if (route instanceof NavigationEnd) {
            this.activeRoute$.next(route.urlAfterRedirects);
          }
        }),
        takeUntilDestroyed()
      )
      .subscribe();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;

          return route;
        }),
        mergeMap((route) => route.paramMap),
        takeUntilDestroyed()
      )
      .subscribe((paramAsMap) => {
        this.paramMap$.next(paramAsMap);
      });
  }
}
